import React from 'react'
import { Link} from 'react-router-dom';

export default function Header() {

 
  return (
    <div >
      <div className="navbar fixed-top navbar-expand-lg navbar-dark bg-secondary" >
        <div className=" container-fluid">
            <h4 className="navbar-brand my-1 mx-5" >College Book</h4>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav">
            
                    <li className="nav-item">
                    <Link className="navbar-brand my-0" to="/">Home</Link>
                    </li>
                    <li className="nav-item dropdown">
                    <a className=" navbar-brand nav-link dropdown-toggle" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Service
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                     
                        <li><Link className="dropdown-item" to="/CSE">CSE</Link></li>
                        <li><Link className="dropdown-item" to="/AE">AE</Link></li>
                        <li><Link className="dropdown-item" to="/ECE">ECE</Link></li>
                        <li><Link className="dropdown-item" to="">GATE</Link></li>
                        
                    </ul>
                    </li>
                    <li className="nav-item">
                    <Link className="navbar-brand my-1" to="/About">About</Link>
                    </li>
                    <li className="nav-item">
                    <Link className="navbar-brand my-1" to="/Contact">Contact</Link>
                    </li>
            </ul>
            
            </div>
        </div>
      </div>
  
   </div>
  );
}
